module.exports = __webpack_public_path__ + "assets/img/pages/SA_bg.svg";